export default {
    TRACK_BILLING_VIEW: 'billing_viewed',
    TRACK_CONTACT_CREATE: 'contact_created',
    TRACK_CONTACT_UPDATE: 'contact_updated',
    TRACK_CONTACT_STAR: 'contact_starred',
    TRACK_CONTACTS_VIEW: 'contact_viewed',
    TRACK_COMPANY_CREATE: 'company_created',
    TRACK_COMPANY_UPDATE: 'company_updated',
    TRACK_ACCOUNTS_VIEW: 'account_viewed',
    TRACK_LEAD_CREATE: 'lead_created',
    TRACK_LEAD_CREATE_UNBOUNCE: 'lead_created_via_unbounce',
    TRACK_LEAD_CREATE_WUFOO: 'lead_created_via_wufoo',
    TRACK_LEAD_CREATE_POST: 'lead_created_via_post',
    TRACK_LEAD_UPDATE: 'lead_updated',
    TRACK_LEADS_VIEW: 'lead_viewed',
    TRACK_LEAD_WON: 'lead_won',
    TRACK_LEAD_LOST: 'lead_lost',
    TRACK_LEAD_CANCELLED: 'lead_cancelled',
    TRACK_LEAD_ASSIGNED: 'lead_assigned',
    TRACK_LEAD_WATCHED: 'lead_watched',
    TRACK_LEAD_SENDTO: 'lead_sendto',
    TRACK_HOT_LEADS_ENABLED: 'hotleads_enabled',
    TRACK_LEAD_VALUE_MODE_CHANGE: 'lead_value_mode_changed',
    TRACK_LEAD_CREATED_MANUAL_VALUE: 'lead_created_manual_value',
    TRACK_LEAD_STAGE_CHANGE: 'lead_changed_stage',
    TAACK_SALES_STEP_COMPLETE: 'sales_step_completed',
    TRACK_SALES_QUOTA_CHANGE: 'sales_quota_changed',
    TRACK_ACTIVITY_QUOTA_CHANGE: 'activity_quota_changed',
    TRACK_STAGE_UPDATE: 'stage_updated',
    TRACK_SALES_PROCESS_CREATE: 'sales_process_created',
    TRACK_SALES_PROCESS_CHANGE: 'sales_process_changed',
    TRACK_SALES_PROCESS_DELETE: 'sales_process_deleted',
    TRACK_SALES_PROCESS_SET_DEFAULT: 'sales_process_default_for_leads_set',
    TRACK_SALES_PROCESS_LEAD_ADD: 'sales_process_added_to_lead',
    TRACK_SALES_PROCESS_LEAD_REMOVE: ' sales_proces_removed_from_lead',
    TRACK_ACTIVITY_SCHEDULED: 'activity_scheduled',
    TRACK_ACTIVITY_LOGGED: 'activity_logged',
    TRACK_ACTIVITY_TYPE_CHANGE: 'activity_type_changed',
    TRACK_ACTIVITY_CREATED_VIA_MODAL: 'activity_created_via_modal',
    TRACK_ACTIVITY_SUMMARY_GENERATED_VIA_MODAL: 'activity_summary_generated_via_modal',
    TRACK_ACTIVITY_MODAL_TAB_VIEWED: 'activity_modal_tab_viewed',
    TRACK_EMAIL_SEND: 'email_sent',
    TRACK_EMAIL_REPLY_SEND: 'email_reply_sent',
    TRACK_EMAIL_CREATE: 'email_added',
    TRACK_EMAIL_SMTP_OLD_TLS_CONNECTED: 'email_smtp_old_tls_connected',
    TRACK_NOTIFICATIONS_CLICK: 'notifications_clicked',
    TRACK_NOTIFICATION_CLICK: 'notification_clicked',
    TRACK_NOTIFICATION_READ: 'notifications_read',
    TRACK_NOTIFICATION_CHANGE: 'notification_changed',
    TRACK_NOTIFICATION_INAPP_ALL_ENABLE: 'in-app_notifications_enabled',
    TRACK_NOTIFICATION_EMAIL_ALL_ENABLE: 'email_notifications_enabled',
    TRACK_NOTIFICATION_MOBILE_ALL_ENABLE: 'mobile_notifications_enabled',
    TRACK_EMAIL_ADD: 'email_added',
    TRACK_EMAIL_SHARE: 'email_shared',
    TRACK_EMAIL_UNSHARE: 'email_unshared',
    TRACK_EMAIL_INTERNAL_DOMAIN_ADDED: 'email_internal_domain_added',
    TRACK_EMAIL_ALL_DELETED_BY_ADDRESS: 'email_all_deleted_by_address',
    TRACK_EMAIL_BLOCKLISTED_VIA_ADD: 'email_blocklisted_via_add',
    TRACK_EMAIL_BLOCKLISTED_VIA_DELETE: 'email_blocklisted_via_delete',
    TRACK_EMAIL_SCHEDULED: 'email_scheduled',
    TRACK_EMAIL_SEQUENCE_TEMPLATE_GROUP_CREATE: 'email_sequence_template_group_created',
    TRACK_EMAIL_SEQUENCE_TEMPLATE_GROUP_ARCHIVED: 'email_sequence_template_group_archived',
    TRACK_EMAIL_SEQUENCE_TEMPLATE_CREATE: 'email_sequence_template_created',
    TRACK_EMAIL_SEQUENCE_TEMPLATE_CATEGORIZED: 'email_sequence_template_group_categorized',
    TRACK_EMAIL_INBOX_PAGE_VIEWED: 'email_inbox_page_view',
    TRACK_EMAIL_SENT_PAGE_VIEWED: 'email_sent_page_view',
    TRACK_EMAIL_SCHEDULED_PAGE_VIEWED: 'email_scheduled_page_view',
    TRACK_EMAIL_FAILED_PAGE_VIEWED: 'email_failed_page_view',
    TRACK_DRIP_REPLY_RECEIVED: 'email_drip_reply_received',
    TRACK_EMAIL_DRIP_MESSAGE_DELAYED: 'drip_message_delayed',
    TRACK_EMAIL_MODAL_OPENED_FROM_LIST: 'modal_opened_from_list',
    TRACK_EMAIL_MODAL_OPENED_FROM_ENTITY: 'modal_opened_from_entity',
    TRACK_EMAIL_MODAL_OPENED_FROM_DASHBOARD: 'modal_opened_from_dashboard',
    TRACK_EMAIL_MODAL_OPENED_FROM_UNKNOWN: 'modal_opened_from_unknown',
    TRACK_FOLLOWUP_CREATE: 'kit_created',
    TRACK_FOLLOWUP_SNOOZE: 'kit_snoozed',
    TRACK_FOLLOWUP_REMINDER_VIEW: 'kit_reminder_viewed',
    TRACK_FOLLOWUP_SUCCESS: 'kit_successful',
    TRACK_LIST_COLUMN_ADD: 'list_column_added',
    TRACK_LIST_COLUMN_REMOVE: 'list_column_removed',
    TRACK_LIST_FILTER_SAVE: 'list_filter_saved',
    TRACK_LIST_FILTER_VIEW: 'list_filter_viewed',
    TRACK_DASHBOARD_CARD_CREATE: 'dashboard_card_created',
    TRACK_DASHBOARD_CARD_UPDATE: 'dashboard_card_updated',
    TRACK_DASHBOARD_CARD_DELETE: 'dashboard_card_deleted',
    TRACK_REPORT_FORECAST_VIEW: 'forecast_report_viewed',
    TRACK_REPORT_ACTIVITY_VIEW: 'activity_report_viewed',
    TRACK_REPORT_EMAIL_VIEW: 'email_report_viewed',
    TRACK_REPORT_ATTRIBUTION_VIEW: 'attribution_report_viewed',
    TRACK_REPORTSCUSTOM_VIEW: 'custom_report_viewed',
    TRACK_REPORTSFUNNEL_VIEW: 'funnel_report_viewed',
    TRACK_REPORT_SALES_VIEW: 'sales_report_viewed',
    TRACK_REPORT_LOSSES_VIEW: 'losses_report_viewed',
    TRACK_REPORT_NEW_LEADS_VIEW: 'new_leads_report_viewed',
    TRACK_REPORT_SNAPSHOTS_VIEW: 'snapshots_report_viewed',
    TRACK_REPORT_EDITION_OPEN_CLICK_VIEW: 'edition_open_click_report_viewed',
    TRACK_REPORT_TASK_VIEW: 'task_report_viewed',
    TRACK_AUDIENCE_REPORT_VIEW: 'audience_report_viewed',
    TRACK_REPORT_ENGAGEMENT_VIEW: 'engagement_report_viewed',
    TRACK_REPORT_CHATBOT_VIEW: 'chatbot_report_viewed',
    TRACK_REPORT_SCHEDULER_VIEW: 'scheduler_report_viewed',
    TRACK_REPORT_CHART_DOWNLOAD: 'report_chart_downloaded',
    TRACK_ACCOUNT_LOGO_UPDATE: 'account_logo_updated',
    TRACK_ACCOUNT_SETTING_CHANGE: 'account_setting_changed',
    TRACK_DATA_EXPORT: 'full_data_export',
    TRACK_PAYMENT_UPDATE: 'payment_details_updated',
    TRACK_PAYMENT_MADE: 'payment_made',
    TRACK_PAYMENT_ERROR: 'payment_error',
    TRACK_CUSTOMER_TRIAL: 'account_trial_signup',
    TRACK_CUSTOMER_SIGNUP: 'account_trial_converted',
    TRACK_CUSTOMER_TRIAL_MODAL_SWAP_VIEW: 'account_trial_swap_modal_viewed',
    TRACK_CUSTOMER_TRIAL_UPGRADE: 'account_trial_upgraded',
    TRACK_CUSTOMER_TRIAL_DOWNGRADE: 'account_trial_downgraded',
    TRACK_CUSTOMER_CANCEL_VIEW: 'account_cancel_viewed',
    TRACK_CUSTOMER_CANCELLATION_FORM_SUBMITTED: 'account_cancellation_form_submitted',
    TRACK_CUSTOMER_CANCEL_REQUEST: 'account_cancel_requested',
    TRACK_CUSTOMER_SEATS_ADD: 'account_seats_added',
    TRACK_CUSTOMER_SEATS_REMOVE: 'account_seats_removed',
    TRACK_CUSTOMER_PLAN_UPGRADE: 'account_plan_upgraded',
    TRACK_CUSTOMER_PLAN_DOWNGRADE: 'account_plan_downgrade',
    TRACK_CUSTOMER_PLAN_CHANGE: 'account_plan_chaged',
    TRACK_CUSTOMER_PLAN_RENEWAL: 'account_plan_renewed',
    TRACK_CUSTOMER_PLAN_MARKETING_ADD: 'account_plan_marketing_add',
    TRACK_CUSTOMER_PLAN_MARKETING_CHANGE: 'account_plan_marketing_change',
    TRACK_CUSTOMER_PLAN_MARKETING_REMOVED: 'account_plan_marketing_removed',
    TRACK_CUSTOMER_PLAN_VISITORIQ_ADD: 'account_plan_visitoriq_add',
    TRACK_CUSTOMER_PLAN_VISITORIQ_CHANGE: 'account_plan_visitoriq_change',
    TRACK_CUSTOMER_PLAN_VISITORIQ_REMOVED: 'account_plan_visitoriq_removed',
    TRACK_CUSTOMER_PLAN_ENGAGEMENT_ADD: 'account_plan_engagement_add',
    TRACK_CUSTOMER_PLAN_ENGAGEMENT_CHANGE: 'account_plan_engagement_change',
    TRACK_CUSTOMER_PLAN_ENGAGEMENT_REMOVED: 'account_plan_engagement_removed',
    TRACK_CUSTOMER_PLAN_MARKETING_SUITE_ADD: 'account_plan_marketing_suite_add',
    TRACK_CUSTOMER_PLAN_MARKETING_SUITE_CHANGE: 'account_plan_marketing_suite_change',
    TRACK_CUSTOMER_PLAN_MARKETING_SUITE_REMOVED: 'account_plan_marketing_suite_removed',
    TRACK_CUSTOMER_PLAN_SMS_CAMPAIGNS_ADD: 'account_plan_sms_campaigns_add',
    TRACK_CUSTOMER_PLAN_SMS_CAMPAIGNS_CHANGE: 'account_plan_sms_campaigns_change',
    TRACK_CUSTOMER_PLAN_SMS_CAMPAIGNS_REMOVED: 'account_plan_sms_campaigns_removed',
    TRACK_CUSTOMER_PLAN_QUOTES_ADD: 'account_plan_quotes_add',
    TRACK_CUSTOMER_PLAN_QUOTES_CHANGE: 'account_plan_quotes_change',
    TRACK_CUSTOMER_PLAN_QUOTES_REMOVED: 'account_plan_quotes_removed',
    TRACK_CUSTOMER_PLAN_NUTSHELL_ADVISOR_ADD: 'account_plan_nutshell_advisor_add',
    TRACK_CUSTOMER_PLAN_NUTSHELL_ADVISOR_CHANGE: 'account_plan_nutshell_advisor_change',
    TRACK_CUSTOMER_PLAN_NUTSHELL_ADVISOR_REMOVED: 'account_plan_nutshell_advisor_removed',
    TRACK_USER_INVITE: 'user_invited',
    TRACK_USER_ADD: 'user_add',
    TRACK_TEAM_CREATE: 'team_created',
    TRACK_TEAM_DELETE: 'team_deleted',
    TRACK_TEAM_USER_ASSIGN: 'user_assigned_to_team',
    TRACK_USER_AVATAR_UPDATE: 'user_avatar_updated',
    TRACK_USER_PASSWORD_UPDATE: 'user_password_updated',
    TRACK_USER_EMAIL_VERIFY: 'user_email_verified',
    TRACK_USER_ADMIN_GRANT: 'user_admin_granted',
    TRACK_USER_ADMIN_REVOKE: 'user_admin_revoked',
    TRACK_USER_ENABLED: 'user_enabled',
    TRACK_USER_DISABLE: 'user_disabled',
    TRACK_USER_FIRST_SESSION_CREATED: 'user_first_session_created',
    TRACK_USER_MARKETING_ROLE_ADD: 'user_marketing_role_added',
    TRACK_USER_MARKETING_ROLE_REMOVE: 'user_marketing_role_remove',
    TRACK_USER_MARKETING_ROLE_INVITE: 'user_marketing_role_invite',
    TRACK_INTEGRATION_ENABLE: 'app_integration_enabled',
    TRACK_INTEGRATION_REVOKE: 'app_integration_revoked',
    TRACK_GOOGLE_APPS_ENABLE: 'google_apps_integration_enabled',
    TRACK_GOOGLE_APPS_REVOKE: 'google_apps_integration_revoked',
    TRACK_GOOGLE_SYNC_ENABLE_ATTEMPT: 'google_sync_integration_enabled_attempt',
    TRACK_GOOGLE_SYNC_ENABLE: 'google_sync_integration_enabled',
    TRACK_GOOGLE_SYNC_REVOKE: 'google_sync_integration_revoked',
    TRACK_GOOGLE_CAL_SYNC_ATTEMPT: 'google_sync_attempt',
    TRACK_GOOGLE_CAL_SYNC_ENABLE: 'google_sync_enabled',
    TRACK_GOOGLE_CAL_SYNC_REVOKE: 'google_sync_revoked',
    TRACK_GOOGLE_EMAIL_SYNC_ENABLE: 'google_email_sync_enabled',
    TRACK_GOOGLE_EMAIL_SYNC_UPDATE: 'google_email_sync_settings_updated',
    TRACK_TWITTER_STATS_ENABLE_ATTEMPT: 'twitter_stats_enable_attempted',
    TRACK_TWITTER_STATS_ENABLE: 'twitter_stats_enabled',
    TRACK_TWITTER_STATS_REVOKE: 'twitter_stats_revoke',
    TRACK_SKYPE_ENABLE: 'skype_integration_enabled',
    TRACK_SKYPE_DISABLE: 'skype_integration_disabled',
    TRACK_RINGCENTRAL_ENABLE: 'ring_central_integration_enabled',
    TRACK_RINGCENTRAL_DISABLE: 'ring_central_integration_disabled',
    TRACK_KIXIE_ENABLE: 'kixie_integration_enabled',
    TRACK_KIXIE_DISABLE: 'kixie_integration_disabled',
    TRACK_MAIL_SYNC_PREFERENCE_CHANGE: 'mail_sync_preferences_changed',
    TRACK_SMTP_CHANGE_ATTEMPT: 'smtp_server_change_attempted',
    TRACK_SMTP_CHANGE: 'smtp_server_changed',
    TRACK_SMTP_DISABLE: 'smtp_server_disabled',
    TRACK_EMAIL_CONFIG_MODAL_PAGE_VIEWED: 'email_config_modal_viewed',
    TRACK_C2C_ATTEMPT_ENABLE: 'click_to_call_enable_attempted',
    TRACK_C2C_ENABLE: 'click_to_call_enabled',
    TRACK_C2C_CALL_ATTEMPTED: 'click_to_call_call_attempted',
    TRACK_C2C_CALL_COMPLETED: 'click_to_call_call_completed',
    TRACK_C2C_TRANSCRIPTION: 'click_to_call_transcription',
    TRACK_C2C_SUMMARY: 'click_to_call_summary',
    TRACK_API_KEY_CREATE: 'api_key_created',
    TRACK_API_KEY_REVOKE: 'api_key_revoked',
    TRACK_IMPORT_ATTEMPT: 'data_import_attempted',
    TRACK_IMPORT: 'data_imported',
    TRACK_IMPORT_TYPE_SELECT: 'data_import_type_selected',
    TRACK_IMPORT_WHITEGLOVE_VIEW: 'data_import_whiteglove_viewed',
    TRACK_IMPORT_WHITEGLOVE_SUBMIT: 'data_import_whiteglove_submitted',
    TRACK_IMPORT2_COMPETITORS_VIEWED: 'import2_competitors_viewed',
    TRACK_IMPORT2_CRM_TYPE_SELECTED: 'import2_crm_type_selected',
    TRACK_IMPORT2_SAMPLE_COMPLETED: 'import2_sample_completed',
    TRACK_IMPORT2_FULL_MIGRATION_COMPLETED: 'import2_full_migration_completed',
    TRACK_DROMO_IMPORT_IMPORTER_OPENED: 'dromo_import_importer_opened',
    PROP_IMPORT_TYPE: 'type',
    TRACK_MARKET_UPDATE: 'updated_markets',
    TRACK_PRODUCT_ADD: 'product_added',
    TRACK_PRODUCT_REMOVE: 'product_removed',
    TRACK_PRODUCT_UPDATE: 'product_updated',
    TRACK_PRODUCT_EXPORT: 'product_exported',
    TRACK_PRODUCT_ADDED_TO_CATEGORY: 'product_added_to_category',
    TRACK_PRODUCT_CATEGORY_CREATED: 'product_category_created',
    TRACK_TASK_CREATE: 'task_created',
    TRACK_NOTE_CREATE: 'note_created',
    TRACK_COMMENT_ADD: 'comment_added',
    TRACK_WALKBOARD_CLICK: 'wallboard_clicked',
    TRACK_OUTCOME_UPDATE: 'updated_outcomes',
    TRACK_CUSTOM_FIELD_CREATE: 'custom_field_created',
    TRACK_CUSTOM_FIELD_UPDATE: 'custom_field_updated',
    TRACK_CUSTOM_FIELD_DELETE: 'custom_field_removed',
    TRACK_CUSTOM_FIELD_PIPELINES_SET: 'custom_field_pipelines_set',
    TRACK_GLOBAL_SEARCH_PERFORMED: 'global_search_performed',
    TRACK_TIMELINE_FILTER_CHANGE: 'timeline_filter_changed',
    TRACK_CALENDAR_FEED_VIEW: 'calendar_feed_viewed',
    TRACK_UPLOAD_LOGO: 'instance_logo_uploaded',
    TRACK_UPLOAD_LOGO_AT_SIGNUP: 'instance_logo_uploaded_at_signup',
    TRACK_GLOBAL_SEARCH_SHORTCUT_USED: 'global_search_shortcut_used',
    TRACK_GLOBAL_SEARCH_SLASH_SHORTCUT_USED: 'global_search_slash_shortcut_used',
    TRACK_VIDEO_POPUP_VIEWED: 'video_popup_viewed',
    TRACK_INSTANCE_TRIAL_EXPIRED_VISITED: 'instance_trial_expired_visited',
    TRACK_INSTANCE_OVERDUE_INVOICE_VISITED: 'instance_overdue_invoice_visited',
    TRACK_ONBOARD_WELCOME_VIEW: 'onboarding_welcome_viewed',
    TRACK_ONBOARD_WELCOME_SKIP: 'onboard_welcome_skipped',
    TRACK_ONBOARD_EXCHANGE_VIEW: 'onboard_exchange_viewed',
    TRACK_ONBOARD_OTHER_VIEW: 'onboarding_other_viewed',
    TRACK_ONBOARD_GOOGLE_VIEW: 'onboarding_google_viewed',
    TRACK_ONBOARD_GOOGLE_SKIP: 'onboarding_google_skipped',
    TRACK_ONBOARD_DEFAULT_STAGSET_WIZARD_COMPLETED: 'onboarding_default_stageset_wizard_completed',
    TRACK_ONBOARD_SIGNUP_INFO_UPDATED: 'onboarding_signup_info_updated',
    TRACK_ONBOARDING_CHECKLIST_INVITE_YOUR_TEAM_CLICKED: 'ob_checklist_invite_your_team_clicked',
    TRACK_ONBOARDING_CHECKLIST_CONNECT_ACCOUNT: 'ob_checklist_connect_account_clicked',
    TRACK_ONBOARDING_CHECKLIST_IMPORT_CONTACTS_CLICKED: 'ob_checklist_import_contacts_clicked',
    TRACK_ONBOARDING_CHECKLIST_CREATE_BROADCAST_CLICKED: 'ob_checklist_create_broadcast_clicked',
    TRACK_ONBOARDING_CHECKLIST_CREATE_FORM_CLICKED: 'ob_checklist_create_form_clicked',
    TRACK_ONBOARDING_CHECKLIST_USE_ANALYTICS_CLICKED: 'ob_checklist_use_analytics_clicked',
    TRACK_SALES_AUTOMATION_FORM_GOAL_SAVED: 'sales_automation_form_goal_saved',
    TRACK_SALES_AUTOMATION_FORM_STEP_TEMPLATE_SAVED: 'sales_automation_form_step_template_saved',
    TRACK_MARKETING_DASHBOARD_VIEWED: 'marketing_dashboard_viewed',
    TRACK_MARKETING_DASHBOARD_DATE_RANGE_CHANGED: 'marketing_dashboard_date_range_changed',
    TRACK_EMAIL_MARKETING_CHILD_TEMPLATE_CREATED: 'email_marketing_child_template_created',
    TRACK_AUTOMATIONS_SENDING_VIEWED: 'automations_sending_viewed',
    TRACK_AUTOMATIONS_NEEDS_ATTENTION_VIEWED: 'automations_needs_attention_viewed',
    TRACK_AUTOMATIONS_READY_TO_SEND_VIEWED: 'automations_ready_to_send_viewed',
    TRACK_AUTOMATED_EMAILS_PAUSED: 'automated_emails_paused_toggled',
    TRACK_AUTOMATED_EMAILS_RESUMED: 'automated_emails_resumed_toggled',
    TRACK_AUTOMATION_STATUS_SENT_NOW_FROM_LIST: 'automation_status_sent_now_from_list',
    TRACK_AUTOMATION_STATUS_SENT_NOW_FROM_LEAD_PAGE: 'automation_status_sent_now_from_lead_page',
    TRACK_AUTOMATION_STATUS_MANUALLY_CANCELLED_FROM_LIST: 'automation_status_manually_cancelled_from_list',
    TRACK_AUTOMATION_STATUS_MANUALLY_CANCELLED_FROM_LEAD_PAGE: 'automation_status_manually_cancelled_from_lead_page',
    TRACK_AUTOMATION_STATUS_STARTED_FROM_LIST: 'automation_status_manually_started_from_list',
    TRACK_AUTOMATION_STATUS_STARTED_FROM_LEAD_PAGE: 'automation_status_manually_started_from_lead_page',
    TRACK_AUTOMATION_STATUS_FIELD_UPDATED_FROM_LIST: 'automation_status_field_updated_from_list',
    TRACK_DRIP_SEQUENCE_START_TRIGGER_CREATED: 'drip_sequence_start_trigger_created',
    TRACK_DRIP_SEQUENCE_START_TRIGGER_UPDATED: 'drip_sequence_start_trigger_updated',
    TRACK_DRIP_SEQUENCE_START_TRIGGER_DELETED: 'drip_sequence_start_trigger_deleted',
    TRACK_DRIP_SEQUENCE_GOAL_CREATED: 'drip_sequence_goal_created',
    TRACK_DRIP_SEQUENCE_GOAL_UPDATED: 'drip_sequence_goal_updated',
    TRACK_DRIP_SEQUENCE_GOAL_DELETED: 'drip_sequence_goal_deleted',
    TRACK_DRIP_SEQUENCES_EARLY_ACCESS_REQUEST: 'drip_sequences_early_access_request',
    TRACK_DRIP_SEQUENCE_ACTIVATED: 'drip_sequence_activated',
    TRACK_DRIP_SEQUENCE_CANCELLED: 'drip_sequence_cancelled',
    TRACK_DRIP_SEQUENCE_RETIRED: 'drip_sequence_retired',
    TRACK_DRIP_SEQUENCE_PAUSED: 'drip_sequence_paused',
    TRACK_DRIP_SEQUENCE_UNPAUSED: 'drip_sequence_unpaused',
    TRACK_DRIP_SEQUENCE_CREATED: 'drip_sequence_created',
    TRACK_DRIP_SEQUENCE_ACTIVE_EDITION_EDITED: 'drip_sequence_active_edition_edited',
    TRACK_DRIP_SEQUENCE_MESSAGE_SENT: 'drip_sequence_message_sent',
    TRACK_WEBCAST_DEMIO_REGISTER_CLICKED: 'webcast_demio_register_clicked',
    TRACK_OFFICE365_ATTEMPT: 'office365_integration_attempted',
    TRACK_OFFICE365_ENABLE: 'office365_integration_enabled',
    TRACK_OFFICE365_REVOKE: 'office365_revoked',
    TRACK_SLACK_ATTEMPT: 'slack_integration_attempted',
    TRACK_SLACK_ENABLE: 'slack_integration_enabled',
    TRACK_SLACK_AUTOMATION_CREATED: 'slack_automation_created',
    TRACK_SLACK_MESSAGE_POSTED: 'slack_message_posted',
    TRACK_SLACK_UNFURL_POSTED: 'slack_unfurl_posted',
    TRACK_INTERCOM_ATTEMPT: 'intercom_integration_attempted',
    TRACK_INTERCOM_ENABLE: 'intercom_integration_enabled',
    TRACK_EMAIL_ADDIN_AUTHENTICATE: 'email_addin_authenticated',
    TRACK_EMAIL_ADDIN_SESSION_START: 'email_addin_session_started',
    TRACK_EMAIL_ADDIN_LOGOUT: 'email_addin_session_did_logout',
    TRACK_EMIAIL_ADDIN_ROOT_SCREEN_VIEWED: 'email_addin_root_screen_viewed',
    TRACK_CTA_BANNER_IMPORT_CLICKED: 'cta_banner_import_clicked',
    TRACK_CTA_SALES_BOOKING_CLICKED: 'cta_banner_sales_booking_clicked',
    TRACK_SETTING_NUTSHELL_INTELLIGENCE_ENABLED: 'setting_nutshell_intelligence_enabled',
    TRACK_SETTING_NUTSHELL_INTELLIGENCE_DISABLED: 'setting_nutshell_intelligence_disabled',
    TRACK_LEAD_PRIORITY_HOT_SET: 'lead_hot_set',
    TRACK_LEAD_PRIORITY_NORMAL_SET: 'lead_hot_unset',
    TRACK_BUSINESS_HOURS_SET: 'business_hours_set_by_initial_timezone',
    TRACK_TINYINTRO_SLIDE_VIEWED: 'tinyintro_slide_viewed',
    TRACK_TINYINTRO_JOIN_YOUR_TEAM_VIEWED: 'tinyintro_join_your_team_viewed',
    TRACK_TINYINTRO_INVITE_REQUESTED: 'tinyintro_invite_requested',
    TRACK_EM_LOTC_0_INTRODUCTION: 'em_lotc_0_introduction',
    TRACK_EM_LOTC_1_EMAIL_OUTREACH: 'em_lotc_1_email_outreach',
    TRACK_EM_LOTC_2_AUDIENCES_RECEIVE_OUTREACH: 'em_lotc_2_audiences_receive_outreach',
    TRACK_EM_LOTC_3_HOW_IT_FITS: 'em_lotc_3_how_it_fits',
    TRACK_EM_LOTC_4_GET_STARTED: 'em_lotc_3_get_started',
    TRACK_EM_LOTC_UNKNOWN_VIEWED: 'em_lotc_unknown_viewed',
    TRACK_BULK_LEAD_CREATION_COMPANIES_LIST: 'bulk_lead_companies_list_creation',
    TRACK_BULK_LEAD_ASSOCIATION_COMPANIES_LIST: 'bulk_lead_companies_list_association',
    TRACK_BULK_LEAD_CREATION_PEOPLE_LIST: 'bulk_lead_people_list_creation',
    TRACK_BULK_LEAD_ASSOCIATION_PEOPLE_LIST: 'bulk_lead_people_list_association',
    TRACK_FROM_LIST_SEND_EDITION: 'from_list_send_edition',
    TRACK_FROM_LIST_ADD_TO_DRIP_SEQUENCE: 'from_list_add_to_drip_sequence',
    TRACK_MAILCHIMP_LIST_EXPORT: 'mailchimp_list_export_started',
    TRACK_QUICKBOOKS_CUSTOMER_CREATED_OR_UPDATED: 'quickbooks_customer_created_or_updated',
    TRACK_QUICKBOOKS_INVOICE_CREATED: 'quickbooks_invoice_created',
    TRACK_EMAIL_MARKETING_EARLY_ACCESS_REQUEST: 'email_marketing_early_access_request',
    TRACK_EM_STREET_ADDR_SET: 'em_street_addr_set',
    TRACK_EM_FROMADDRESS_CONFIRMED: 'em_fromaddress_confirmed',
    TRACK_EM_MAILFROMDOMAIN_CONFIRMED: 'em_mailfromdomain_confirmed',
    TRACK_EM_DOMAINDKIM_CONFIRMED: 'em_domaindkim_confirmed',
    TRACK_EM_SITESTATUS_CONFIRMED: 'em_sitestatus_confirmed',
    TRACK_EM_EDITION_CREATED: 'em_edition_created',
    TRACK_EM_NEWSLETTER_CREATED: 'em_newsletter_created',
    TRACK_EM_TEST_EMAIL_SENT: 'em_test_email_sent',
    TRACK_EM_EMAIL_SENT: 'em_email_sent',
    TRACK_EM_CAMPAIGN_SCHEDULED: 'em_campaign_scheduled',
    TRACK_EM_CAMPAIGN_SENT: 'em_campaign_sent',
    TRACK_EM_AUDIENCE_CREATED: 'em_audience_created',
    TRACK_EM_AUDIENCE_IMPORTED: 'em_audience_imported',
    TRACK_EM_AUDIENCE_ADDED_FROM_LIST: 'em_audience_added_from_list',
    TRACK_EM_RECIPIENT_UNSUBSCRIBED: 'em_recipient_unsubscribed',
    TRACK_EM_BOUNCED_PERMANENT: 'em_bounced_permanent',
    TRACK_EM_BOUNCED_TEMPORARY: 'em_bounced_temporary',
    TRACK_EM_COMPLAINT: 'em_complaint',
    TRACK_EM_STARTED_EDITION_DUPLICATED: 'em_starter_edition_duplicated',
    TRACK_EM_EDITION_COMPLETED: 'em_edition_completed',
    TRACK_EM_EDITION_FAILED: 'em_edition_failed',
    TRACK_WF_FORM_CREATED: 'wf_form_created',
    TRACK_WF_FORM_PUBLISHED: 'wf_form_published',
    TRACK_WF_FORM_EMBEDDED_SUBMITTED: 'wf_form_embedded_submitted',
    TRACK_WF_FORM_PAGE_SUBMITTED: 'wf_form_page_submitted',
    TRACK_SPAM_PREVENTION_TYPE_CHANGED: 'wf_form_spam_prevention_type_changed',
    TRACK_SUBMISSIONS_CSV_DOWNLOADED: 'wf_form_submissions_csv_downloaded',
    TRACK_2FA_USER_CONFIGURATION_STARTED: '2fa_user_configuration_started',
    TRACK_2FA_USER_ENABLED: '2fa_user_enabled',
    TRACK_2FA_USER_DISABLED: '2fa_user_disabled',
    TRACK_2FA_ADMIN_RESET: '2fa_admin_reset',
    TRACK_2FA_ADMIN_ENFORCED: '2fa_admin_enforced',
    TRACK_TIMELINE_ENTITY_REACTION: 'timeline_entity_reaction',
    TRACK_TIMELINE_FILTER_DATE_RANGE: 'timeline_filter_date_range',
    TRACK_TIMELINE_FILTER_ACTIVITY_TYPE: 'timeline_filter_activity_type',
    TRACK_ANALYTICS_EMBED_CODE_COPIED: 'analytics_embed_code_copied',
    TRACK_ANALYTICS_GET_HELP_FORM_VIEWED: 'analytics_get_help_form_viewed',
    TRACK_ANALYTICS_GET_HELP_FORM_SUBMITTED: 'analytics_get_help_form_submitted',
    TRACK_ANALYTICS_PAYLOAD_PROCESSED: 'analytics_payload_processed',
    TRACK_ANALYTICS_PAYLOAD_FAILED: 'analytics_payload_failed',
    TRACK_CREATE_MODAL_LEAD_FIELDS_UPDATED: 'create_modal_lead_fields_update',
    TRACK_CREATE_MODAL_CONTACT_FIELDS_UPDATED: 'create_modal_contact_fields_update',
    TRACK_CREATE_MODAL_ACCOUNT_FIELDS_UPDATED: 'create_modal_account_fields_update',
    TRACK_SOURCES_ONBOARDING_STARTED: 'sources_onboarding_started',
    TRACK_SOURCES_ONBOARDING_COMPLETED: 'sources_onboarding_completed',
    TRACK_ATTRIBUTION_ONBOARDING_STARTED: 'attribution_onboarding_started',
    TRACK_ATTRIBUTION_ONBOARDING_COMPLETED: 'attribution_onboarding_completed',
    TRACK_CONNECTED_FORM_ACTIVATE: 'connected_form_activated',
    TRACK_CONNECTED_FORM_NOT_ACTIVATED: 'connected_form_unignored',
    TRACK_CONNECTED_FORM_IGNORED: 'connected_form_ignored',
    TRACK_CONNECTED_FORM_RENAMED: 'connected_form_renamed',
    TRACK_CONNECTED_FORM_FIELD_MAPPED: 'connected_form_field_mapped',
    TRACK_CONNECTED_FORM_FIELD_IGNORED: 'connected_form_field_ignored',
    TRACK_CONNECTED_FORM_LEARN_MORE_CLICKED: 'connected_form_learn_more_clicked',
    TRACK_CONNECTED_FORM_SETUP_TRACKING_CLICKED: 'connected_form_setup_tracking_clicked',
    TRACK_CONNECTED_FORM_SUBMISSION_PROCESSED: 'connected_form_submission_processed',
    TRACK_PINNED_NOTES_PIN: 'pinned_notes_pin',
    TRACK_PINNED_NOTES_REMOVE_PIN: 'pinned_notes_remove_pin',
    TRACK_IE_DEPRECATION_NOTICE_SHOWN: 'deprecation_notice_ie_shown',
    TRACK_CT_UNLOCK: 'company_tracker_unlock',
    TRACK_CT_CONVERT: 'company_tracker_convert',
    TRACK_CT_FILTERS_CHANGED: 'company_tracker_filters_changed',
    TRACK_VIQ_PAGE_VIEWED: 'visitor_iq_page_viewed',
    TRACK_VIQ_SIDEBAR_OPENED: 'visitor_iq_sidebar_opened',
    TRACK_VIQ_ACCOUNT_CONVERT: 'visitor_iq_account_convert',
    TRACK_VIQ_CONTACT_CONVERT: 'visitor_iq_contact_convert',
    TRACK_VIQ_LEAD_ADD: 'visitor_iq_lead_add',
    TRACK_PIQ_SIDEBAR_ACCOUNT_OPENED: 'people_iq_sidebar_account_opened',
    TRACK_PIQ_SIDEBAR_LEAD_OPENED: 'people_iq_sidebar_lead_opened',
    TRACK_PIQ_CONTACT_CONVERT_FROM_ACCOUNT: 'people_iq_contact_convert_from_account',
    TRACK_PIQ_CONTACT_CONVERT_FROM_LEAD: 'people_iq_contact_convert_from_lead',
    TRACK_PROSPECTOR_CONTACT_CONVERT: 'prospector_contact_convert',
    TRACK_CROSSSELL_SERVICES_VIEWED: 'crosssell_services_viewed',
    TRACK_COMPANY_ENRICHMENT_ACCEPTED: 'company_enrichment_accepted',
    TRACK_CONTACT_ENRICHMENT_ACCEPTED: 'contact_enrichment_accepted',
    TRACK_CONTACT_ENRICHMENT_DECLINED: 'contact_enrichment_declined',
    TRACK_SCHEDULER_EMBEDDED_SUBMITTED: 'scheduler_form_embedded_submitted',
    TRACK_SCHEDULER_PAGE_SUBMITTED: 'scheduler_form_page_submitted',
    TRACK_SCHEDULER_MEETING_CREATED: 'scheduler_meeting_created',
    TRACK_SCHEDULER_MULTIHOST_MEETING_CREATED: 'scheduler_multihost_meeting_created',
    TRACK_SCHEDULER_ROUND_ROBIN_MEETING_CREATED: 'scheduler_round_robin_meeting_created',
    TRACK_CONNECTED_CALENDAR_VIA_SCHEDULER: 'connected_calendar_via_scheduler',
    TRACK_SCHEDULER_BOOKING_PAGE_VIEWED: 'scheduler_booking_page_viewed',
    TRACK_SCHEDULER_INDEX_PAGE_VIEWED: 'scheduler_index_page_viewed',
    TRACK_SCHEDULER_BOOKING_CREATED: 'scheduler_booking_created',
    TRACK_SCHEDULER_EMBED_CODE_COPIED: 'scheduler_embed_code_copied',
    TRACK_REVENUE_BOOSTER_TRIAL_STARTED: 'revenue_booster_trial_started',
    TRACK_TRANSCRIPTION_OVERRUN: 'transcription_overrun',
    TRACK_ENTITY_SUMMARY_COMPLETED: 'entity_summary_completed',
    TRACK_ENTITY_SUMMARY_RATED_NEGATIVE: 'entity_summary_rated_negative',
    TRACK_ENTITY_SUMMARY_RATED_POSITIVE: 'entity_summary_rated_positive',
    TRACK_TRANSCRIPTION_STARTED: 'speech_to_text_started',
    TRACK_TRANSCRIPTION_FINISHED: 'speech_to_text_finished',
    TRACK_ROLE_CREATED: 'role_created',
    TRACK_ROLE_DELETED: 'role_deleted',
    TRACK_ROLE_PERMISSIONS_UPDATED: 'role_permissions_updated',
    TRACK_CIQ_COMING_SOON_OPT_IN: 'ciq_coming_soon_opt_in',
    TRACK_COMPETITOR_IQ_MARKETING_LINK_CLICKED: 'competitor_iq_marketing_link_clicked',
    TRACK_COMPETITOR_IQ_WEBSITE_SET_SUCCESFULLY: 'competitor_iq_website_set_successfully',
    TRACK_COMPETITOR_IQ_WEBSITE_NO_VISIT_DATA: 'competitor_iq_website_no_visit_data',
    TRACK_COMPETITOR_IQ_COMPETITOR_SET_SUCCESSFULLY: 'competitor_iq_competitor_set_successfully',
    TRACK_COMPETITOR_IQ_COMPETITOR_NO_VISIT_DATA: 'competitor_iq_competitor_no_visit_data',
    TRACK_COMPETITOR_IQ_PAGE_VIEWED: 'competitor_iq_page_viewed',
    TRACK_COMPETITOR_IQ_WEBSITES_UPDATED: 'competitor_iq_websites_updated',
    TRACK_CHURN_DEFLECTION_CLOSING_ORG: 'churn_deflection_closing_org',
    TRACK_CHURN_DEFLECTION_TOO_EXPENSIVE: 'churn_deflection_too_expensive',
    TRACK_CHURN_DEFLECTION_INTEGRATION_MISSING: 'churn_deflection_integration_missing',
    TRACK_CHURN_DEFLECTION_NOT_ENOUGH_VALUE: 'churn_deflection_not_enough_value',
    TRACK_CHURN_DEFLECTION_NOT_ENOUGH_FUNCTIONALITY: 'churn_deflection_not_enough_functionality',
    TRACK_CHURN_DEFLECTION_HARD_TIME_GETTING_STARTED: 'churn_deflection_hard_time_getting_started',
    TRACK_AB_CREATED: 'ab_created',
    TRACK_AB_SCHEDULED: 'ab_scheduled',
    TRACK_AB_DUPLICATED: 'ab_duplicated',
    TRACK_AB_SEND: 'ab_send',
    TRACK_EDITION_CONVERTED_TO_AB: 'edition_to_ab',
    TRACK_LANDING_PAGE_CREATED: 'landing_page_created',
    TRACK_LANDING_PAGE_PUBLISHED: 'landing_page_published',
    TRACK_LANDING_PAGE_CUSTOM_HOSTING: 'landing_page_custom_hosting',
    TRACK_LANDING_PAGE_FORM_EMBEDDED: 'landing_page_form_embedded',
    TRACK_LANDING_PAGE_SCHEDULER_EMBEDDED: 'landing_page_scheduler_embedded',
    TRACK_CUSTOM_DOMAIN_CREATED: 'custom_domain_created',
    TRACK_TAG_COLOR_CHANGED: 'tag_color_changed',
    TRACK_TAG_CREATED_WITH_COLOR: 'tag_created_with_color',
    TRACK_CUE_CARD_CLICKED: 'cue_clicked',
    TRACK_GLOSSARY_OPENED: 'glossary_opened',
    TRACK_LEAD_CARD_FIELDS_UPDATED: 'lead_card_fields_updated',
    TRACK_ACCOUNT_HIERARCHY_CHILD_ADDED_TO_NEW_PARENT: 'account_hierarchy_child_added_to_new_parent',
    TRACK_ACCOUNT_HIERARCHY_CHILD_ADDED_TO_EXISTING_PARENT: 'account_hierarchy_child_added_to_existing_parent',
    TRACK_ACCOUNT_HIERARCHY_PARENT_SET_ON_CHILD: 'account_hierarchy_parent_set_on_child',
    TRACK_GMAIL_SEND: 'gmail_send',
    TRACK_GMAIL_TEMPLATES_LOAD: 'gmail_templates_load',
    TRACK_GMAIL_TEMPLATE_INSERT: 'gmail_template_insert',
    TRACK_OUTLOOK_TEMPLATE_INSERT: 'outlook_template_insert',
    TRACK_ZOOM_INTEGRATION_ENABLED: 'zoom_integration_enabled',
    TRACK_ZOOM_TRANSCRIPTION: 'zoom_transcription_added_to_activity',
    TRACK_ZOOM_SUMMARY: 'zoom_summary_added_to_activity',
    TRACK_ZOOM_LOGGING_FLOW_INITIATED: 'zoom_logging_flow_initiated',
    TRACK_ZOOM_LOGGED_AS_NEW_ACTIVITY: 'zoom_logged_as_new_activity',
    TRACK_ZOOM_MEETING_AUTO_LOGGED: 'zoom_meeting_auto_logged',
    TRACK_GOOGLE_MEET_INTEGRATION_ENABLED: 'google_meet_integration_enabled',
    TRACK_GOOGLE_MEET_TRANSCRIPTION: 'google_meet_transcription_added_to_activity',
    TRACK_GOOGLE_MEET_SUMMARY: 'google_meet_summary_added_to_activity',
    TRACK_GOOGLE_MEET_LOGGING_FLOW_INITIATED: 'google_meet_logging_flow_initiated',
    TRACK_GOOGLE_MEET_LOGGED_AS_NEW_ACTIVITY: 'google_meet_logged_as_new_activity',
    TRACK_GOOGLE_MEET_MEETING_AUTO_LOGGED: 'google_meet_meeting_auto_logged',
    TRACK_MICROSOFT_TEAMS_INTEGRATION_ENABLED: 'microsoft_teams_integration_enabled',
    TRACK_MICROSOFT_TEAMS_TRANSCRIPTION: 'microsoft_teams_transcription_added_to_activity',
    TRACK_MICROSOFT_TEAMS_SUMMARY: 'microsoft_teams_summary_added_to_activity',
    TRACK_MICROSOFT_TEAMS_MEETING_AUTO_LOGGED: 'microsoft_teams_meeting_auto_logged',
    TRACK_INBOX_THREAD_STARTED: 'inbox_thread_started',
    TRACK_INBOX_THREAD_CLOSED: 'inbox_thread_closed',
    TRACK_INBOX_THREAD_SNOOZED: 'inbox_thread_snoozed',
    TRACK_INBOX_TEXT_SENT: 'inbox_text_sent',
    TRACK_INBOX_TEXT_RECEIVED: 'inbox_text_received',
    TRACK_INBOX_TEXT_OPTOUT: 'inbox_text_optout',
    TRACK_INBOX_TEXT_OPTIN: 'inbox_text_optin',
    TRACK_INBOX_PHONE_PROVISIONED: 'inbox_phone_provisioned',
    TRACK_INBOX_ENROLLMENT_STARTED: 'inbox_enrollment_started',
    TRACK_INBOX_ENROLLMENT_SUBMITTED: 'inbox_enrollment_submitted',
    TRACK_CHAT_OPENED: 'chat_opened',
    TRACK_CHAT_INTAKE_FORM_SUBMITTED: 'chat_intake_form_submitted',
    TRACK_CHAT_OFFLINE_FORM_SUBMITTED: 'chat_offline_form_submitted',
    TRACK_CHAT_AGENT_STATUS_CHANGED: 'chat_agent_status_changed',
    TRACK_CHAT_CUSTOM_WIDGET_ICON_UPLOADED: 'chat_custom_widget_icon_uploaded',
    TRACK_CHAT_IMAGE_SENT: 'chat_image_sent',
    TRACK_CHAT_CONVERSATIONAL_INTAKE_FORM_ENABLED: 'chat_conversational_intake_form_enabled',
    TRACK_CHAT_CONVERSATIONAL_OFFLINE_FORM_ENABLED: 'chat_conversational_offline_form_enabled',
    TRACK_CHAT_MESSAGE_SENT: 'chat_message_sent',
    TRACK_CHATBOT_ONBOARDING_STARTED: 'chatbot_onboarding_started',
    TRACK_CHATBOT_CRAWL_STARTED: 'chatbot_crawl_started',
    TRACK_CHATBOT_CRAWL_COMPLETED: 'chatbot_crawl_completed',
    TRACK_CHATBOT_PREVIEW_VIEWED: 'chatbot_preview_viewed',
    TRACK_CHATBOT_SENT_FIRST_REPLY: 'chatbot_sent_first_reply',
    TRACK_CHATBOT_THAT_HELPED_CLICKED: 'chatbot_that_helped_clicked',
    TRACK_CHATBOT_GOAL_MET: 'chatbot_goal_met',
    TRACK_CHATBOT_RECOMMENDATIONS_GENERATED: 'chatbot_recommendations_generated',
    TRACK_CHATBOT_PAGE_AUTO_CRAWLED: 'chatbot_page_auto_crawled',
    TRACK_ADTECH_FX_MODAL_OPENED: 'adtech_fx_modal_opened',
    TRACK_SEPARATE_ADDRESS_FIELDS_ENABLED: 'separate_address_fields_enabled',
    TRACK_SEPARATE_ADDRESS_FIELDS_DISABLED: 'separate_address_fields_disabled',
    TRACK_CUSTOMER_TRIAL_VISITS_BILLING_HOME: 'trial_customer_visits_billing_home',
    TRACK_CUSTOMER_TRIAL_VISITS_BILLING_TRIAL_SUMMARY: 'trial_customer_visits_billing_summary',
    TRACK_CUSTOMER_TRIAL_VISITS_BILLING_PLAN_PICKER: 'trial_customer_visits_billing_plan_picker',
    TRACK_CUSTOMER_TRIAL_VISITS_BILLING_ADD_ONS: 'trial_customer_visits_billing_add_ons',
    TRACK_CUSTOMER_TRIAL_VISITS_BILLING_REVIEW: 'trial_customer_visits_billing_review',
    TRACK_CUSTOMER_TRIAL_VISITS_BILLING_SUCCESS: 'trial_customer_visits_billing_success',
    TRACK_CUSTOMER_TRIAL_OPENS_PLAN_COMPARISON: 'trial_customer_opens_plan_comparison',
    TRACK_CUSTOMER_TRIAL_VISITS_BILLING_MARKETING: 'trial_customer_visits_billing_marketing',
    TRACK_CUSTOMER_TRIAL_VISITS_BILLING_ENGAGEMENT: 'trial_customer_visits_billing_engagement',
    TRACK_QUOTE_CREATED: 'quote_created',
    TRACK_QUOTE_SENT: 'quote_sent',
    TRACK_QUOTE_DUPLICATED: 'quote_duplicated',
    TRACK_QUOTE_DOWNLOADED: 'quote_downloaded',
    TRACK_QUOTE_TEMPLATE_EDITED: 'quote_template_edited',
    TRACK_QUOTE_PUBLISHED: 'quote_published',
    TRACK_QUOTE_ACCEPTED: 'quote_accepted',
    TRACK_INVOICE_CREATED: 'invoice_created',
    TRACK_INVOICE_SENT: 'invoice_sent',
    TRACK_INVOICE_PUBLISHED: 'invoice_published',
    TRACK_INVOICE_PAID: 'invoice_paid',
    TRACK_INVOICE_TEMPLATE_EDITED: 'invoice_template_edited',
    TRACK_EMAIL_MARKETING_TEMPLATE_CREATED: 'email_marketing_template_created',
    TRACK_EMAIL_MARKETING_TEMPLATE_USED: 'email_marketing_template_used',
    TRACK_MARKETPLACE_INTEGRATION_FORM_SUBMITTED: 'marketplace_integration_form_submitted',
    TRACK_FEATURE_GATE_VIEWED: 'feature_gate_viewed',
    TRACK_ENGAGEMENT_DASHBOARD_VIEWED: 'engagement_dashboard_viewed',
    TRACK_ENGAGEMENT_DASHBOARD_DATE_RANGE_CHANGED: 'engagement_dashboard_date_range_changed',
    TRACK_INBOUND_SMS_THREAD_STARTED: 'inbound_sms_thread_started',
    TRACK_INBOUND_SMS_REDIRECT_NUMBER_CONFIGURED: 'inbound_sms_redirect_number_configured',
    TRACK_INBOUND_SMS_CALL_REDIRECTED: 'inbound_sms_call_redirected',
    TRACK_EXCEPTION_MESSAGE: 'Track exception',
    TRACK_NEW_NAVIGATION_ON: 'global_navigation_2025_opt_in',
    TRACK_NEW_NAVIGATION_OFF: 'global_navigation_2025_opt_out',
    TRACK_SMS_BROADCAST_CREATED: 'sms_broadcast_created',
    TRACK_SMS_BROADCAST_SENT: 'sms_broadcast_sent',
    TRACK_SMS_DRIP_CREATED: 'sms_drip_created',
    TRACK_SMS_DRIP_ACTIVATED: 'sms_drip_activated',
    TRACK_SMS_DRIP_SENT: 'sms_drip_sent',
    TRACK_SCHEDULER_URL_CUSTOMIZED: 'scheduler_url_customized',
    TRACK_FACEBOOK_MESSENGER_MESSAGE_SENT: 'facebook_messenger_message_sent',
    TRACK_FACEBOOK_MESSENGER_MESSAGE_RECEIVED: 'facebook_messenger_message_received',
    TRACK_FACEBOOK_MESSENGER_THREAD_STARTED: 'facebook_messenger_thread_started',
    TRACK_FACEBOOK_MESSENGER_OAUTH_SUCCESS: 'facebook_messenger_oauth_success',
    TRACK_SSO_CONFIGURED: 'sso_configured',
    TRACK_SSO_REQUIRED: 'sso_required',
    TRACK_SSO_EXEMPT_USER_SET: 'sso_exempt_user_set',
    TRACK_SSO_IDP_INITIATED_LOGIN: 'sso_idp_initiated_login',
    TRACK_DIRECTORY_SYNC_CONFIGURED: 'directory_sync_configured',
    TRACK_AUDIENCE_CREATED_ON_ENTITY_LIST_PAGE: 'audience_created_on_entity_list_page',
    TRACK_SAVED_LIST_CREATED_ON_ENTITY_LIST_PAGE: 'saved_list_created_on_entity_list_page',
    TRACK_AI_EMAIL_REPLY_STAGED: 'ai_email_reply_staged',
    TRACK_AI_EMAIL_REPLY_STAGED_FROM_TIMELINE: 'ai_email_reply_staged_from_timeline',
    TRACK_AI_EMAIL_REPLY_ACCEPTED: 'ai_email_reply_accepted',
    TRACK_AI_EMAIL_REPLY_REMOVED: 'ai_email_reply_removed',
    TRACK_CONFLICT_CALENDAR_ADDED: 'conflict_calendar_added',
    TRACK_CONFLICT_CALENDAR_REMOVED: 'conflict_calendar_removed',
    TRACK_PARTNERSTACK_REFERRAL_MODAL_OPENED: 'partnerstack_referral_modal_opened',
    TRACK_PARTNERSTACK_REFERRAL_SIGNUP_TRACKED: 'partnerstack_referral_signup_tracked',
    TRACK_SEO_SCAN_SUBMITTED: 'seo_scan_submitted',
    TRACK_MANAGED_MEETING_CREATED: 'managed_meeting_created',
    TRACK_MANAGED_MEETING_ASSIGNED: 'managed_meeting_assigned',
    TRACK_MANAGED_MEETING_RESET: 'managed_meeting_reset',
    TRACK_AI_ASSISTANT_SIDEBAR_OPENED: 'ai_assistant_sidebar_opened',
    TRACK_AI_ASSISTANT_INITIATED: 'ai_assistant_initiated',
    TRACK_AI_ASSISTANT_CLICK_BUTTON_CLICKED: 'ai_assistant_click_button_clicked',
    TRACK_AI_ASSISTANT_LEAD_PEOPLE_ADDED: 'ai_assistant_lead_people_added',
    TRACK_AI_ASSISTANT_LEAD_NOTE_ADDED: 'ai_assistant_lead_note_added',
    TRACK_WHATSAPP_MESSAGE_SENT: 'whatsapp_message_sent',
    TRACK_WHATSAPP_MESSAGE_RECEIVED: 'whatsapp_message_received',
    TRACK_WHATSAPP_THREAD_STARTED: 'whatsapp_thread_started',
    TRACK_WHATSAPP_OAUTH_SUCCESS: 'whatsapp_oauth_success',
    TRACK_WHATSAPP_MESSAGE_FAILED: 'whatsapp_message_failed',
    TRACK_EPC_PUBLIC_AUDIENCE_UPDATED: 'epc_public_audience_updated',
    TRACK_FORM_ANSWER_RULE_CREATED: 'form_answer_rules_created',
    TRACK_PRESELECTED_FORM_FIELD_CONFIGURED: 'preselected_form_field_configured',
    TRACK_ENTRI_SETUP_COMPLETED: 'entri_setup_completed',
    TRACK_NUTSHELL_SNIPPET_TEST_SUCCESS: 'nutshell_snippet_test_success',
    TRACK_NUTSHELL_SNIPPET_TEST_FAILURE: 'nutshell_snippet_test_failure',
    TRACK_PIPELINE_STARTER_CREATED: 'pipeline_starter_created',
    TRACK_ACTIVITY_TYPE_ICON_CHANGED: 'activity_type_icon_changed',
    TRACK_SALES_AUTOMATION_FOLLOW_UP_LEAD_AUTOMATION_CREATED: 'sales_automation_follow_up_lead_automation_created',
    TRACK_SALES_AUTOMATION_FOLLOW_UP_LEAD_AUTOMATION_TRIGGERED: 'sales_automation_follow_up_lead_automation_triggered',
    TRACK_CALLTRACKERFX_RECORDING_SAVED: 'calltrackerfx_recording_saved',
    TRACK_CALLTRACKERFX_TRANSCRIPTION: 'calltrackerfx_transcription',
    TRACK_CALLTRACKERFX_SUMMARY: 'calltrackerfx_summary',
    TRACK_PEANUT_CHAT_WIDGET_SEEN: 'chat_widget_seen',
    TRACK_PEANUT_CHAT_WIDGET_OPENED: 'chat_widget_opened',
    TRACK_PEANUT_CHAT_NUDGE_CLICKED: 'chat_nudge_clicked',
    TRACK_PEANUT_CHAT_ACTION_BAR_TAB_CLICKED: 'chat_action_bar_tab_clicked',
    TRACK_PEANUT_CHAT_BOOKING_COMPLETED: 'chat_booking_completed',
    TRACK_PEANUT_CHAT_FORM_SUBMITTED: 'chat_form_submitted',
    TRACK_PEANUT_CHAT_ACTIONABLE_BUTTON_CLICKED: 'chat_actionable_button_clicked',
    TRACK_PEANUT_GOOGLE_ANALYTICS_SEND_ATTEMPT: 'google_analytics_send_attempt',
    TRACK_PEANUT_GOOGLE_ANALYTICS_SEND_SUCCESS: 'google_analytics_send_success',
    TRACK_LEAD_PAGE_WIDGET_LAYOUT_CUSTOMIZER_VIEWED: 'lead_page_widget_layout_customizer_viewed',
    TRACK_LEAD_PAGE_WIDGET_LAYOUT_UPDATED: 'lead_page_widget_layout_updated',
    TRACK_LEAD_PAGE_WIDGET_CUSTOM_CUSTOM_FIELD_WIDGET_CREATED: 'lead_page_widget_custom_custom_field_widget_created',
    TRACK_LEAD_PAGE_M3_OPT_OUT: 'lead_page_m3_opt_out',
    TRACK_LEAD_PAGE_M3_OPT_IN: 'lead_page_m3_opt_in',
    TRACK_LEAD_PAGE_M3_FORCE_OPT_IN: 'lead_page_m3_force_opt_in',
    TRACK_DEEPGRAM_TRANSCRIPTION: 'deepgram_transcription',
    TRACK_OAUTH_TOKEN_ISSUED: 'oauth_token_issued',
    TRACK_MCP_REQUEST_MADE: 'mcp_request_made',
    TRACK_OAUTH_ZENDESK_AUTHORIZED: 'oauth_zendesk_authorized',
    TRACK_INTERNAL_FEEDBACK_RESPONSE: 'internal_feedback_response',
    TRACK_ACTIVITY_SYNC_CONTACT_CREATION_ENABLED: 'activity_sync_contact_creation_enabled',
    TRACK_ACTIVITY_SYNC_CONTACT_CREATION_CONTACT_CREATED: 'activity_sync_contact_creation_contact_created',
    TRACK_LEAVE_A_REVIEW_MODAL_VIEWED: 'leave_a_review_modal_viewed',
    TRACK_LEAVE_A_REVIEW_CLICKED: 'leave_a_review_clicked',
    TRACK_REFER_A_FRIEND_MODAL_VIEWED: 'refer_a_friend_modal_viewed',
    TRACK_PIPELINE_ACTIVATED: 'pipeline_activated',
    TRACK_PIPELINE_DEACTIVATED: 'pipeline_deactivated',
    TRACK_PHONE_INTEGRATION_ONBOARD_COMPLETED_AIRCALL: 'phone_integration_onboard_completed_aircall',
    TRACK_AIRCALL_TRANSCRIPTION: 'aircall_transcription_added_to_activity',
    TRACK_AIRCALL_SUMMARY: 'aircall_summary_added_to_activity',
    TRACK_PHONE_INTEGRATION_ONBOARD_COMPLETED_CALLRAIL: 'phone_integration_onboard_completed_callrail',
    TRACK_CALLRAIL_TRANSCRIPTION: 'callrail_transcription_added_to_activity',
    TRACK_CALLRAIL_SUMMARY: 'callrail_summary_added_to_activity',
    TRACK_PHONE_INTEGRATION_ONBOARD_COMPLETED_DIALPAD: 'phone_integration_onboard_completed_dialpad',
    TRACK_DIALPAD_TRANSCRIPTION: 'dialpad_transcription_added_to_activity',
    TRACK_DIALPAD_SUMMARY: 'dialpad_summary_added_to_activity',
    TRACK_PHONE_INTEGRATION_ONBOARD_COMPLETED_RINGCENTRAL: 'phone_integration_onboard_completed_ringcentral',
    TRACK_RINGCENTRAL_TRANSCRIPTION: 'ringcentral_transcription_added_to_activity',
    TRACK_RINGCENTRAL_SUMMARY: 'ringcentral_summary_added_to_activity',
    TRACK_PHONE_INTEGRATION_ONBOARD_COMPLETED_KIXIE: 'phone_integration_onboard_completed_kixie',
    TRACK_KIXIE_TRANSCRIPTION: 'kixie_transcription_added_to_activity',
    TRACK_KIXIE_SUMMARY: 'kixie_summary_added_to_activity',
    TRACK_PHONE_INTEGRATION_ONBOARD_COMPLETED_CLICKTOCALL: 'phone_integration_onboard_completed_clicktocall',
    TRACK_PHONE_INTEGRATION_EXTERNAL_MEETING_CREATED: 'phone_integration_external_meeting_created',
    TRACK_LEAD_PAGE_CALL_BUTTON_CLICKED: 'lead_page_call_button_clicked',
    TRACK_PHONE_INTEGRATION_ONBOARD_FROM_LEAD_PAGE: 'phone_integration_onboard_from_lead_page',
    TRACK_CHURN_SURVEY_TRIGGERED: 'churn_survey_triggered',
    TRACK_CHURN_SURVEY_SUBMITTED: 'churn_survey_submitted',
    TRACK_AI_CAMPAIGN_GENERATED: 'ai_campaign_generated',
    TRACK_AI_CAMPAIGN_REGENERATED: 'ai_campaign_regenerated',
    TRACK_AI_CAMPAIGN_ACCEPTED: 'ai_campaign_accepted',
    TRACK_AI_HOMEPAGE_VIEWED: 'ai_homepage_viewed',
    TRACK_AI_HOMEPAGE_FEATURE_VIEWED: 'ai_homepage_feature_viewed',
    TRACK_AI_HOMEPAGE_FEATURED_TRIED: 'ai_homepage_feature_tried',
    TRACK_AI_REPORT_GENERATED: 'ai_report_generated',
    TRACK_AI_FOLLOWUP_TASK_CREATED: 'ai_followup_task_created',
    TRACK_AI_FOLLOWUP_TASK_UNHELPFUL: 'ai_followup_task_unhelpful',
    TRACK_EXPLORE_PAGE_VIEWED: 'explore_page_viewed',
    TRACK_ONBOARDING_STEP_STARTED: 'onboarding_step_started',
    TRACK_NUTSHELL_TOUR_STARTED: 'nutshell_tour_started',
    TRACK_NUTSHELL_TOUR_COMPLETED: 'nutshell_tour_completed',
    TRACK_EMAIL_DIGEST_SUBSCRIPTION_CHANGED: 'email_digest_subscription_changed',
    TRACK_EMAIL_DIGEST_FREQUENCY_CHANGED: 'email_digest_frequency_changed',
    TRACK_EMAIL_DIGEST_SENT: 'email_digest_sent',
    TRACK_EMAIL_DIGEST_LINK_CLICKED: 'email_digest_link_clicked',
    TRACK_LEAD_RECAP_CREATED: 'lead_recap_created',
    TRACK_LEAD_RECAP_UPDATED: 'lead_recap_updated',
    TRACK_LEAD_RECAP_SUMMARY_GENERATED: 'lead_recap_summary_generated',
    TRACK_MARKETING_AUTOMATION_URL_CREATED: 'marketing_automation_url_created',
    TRACK_MARKETING_AUTOMATION_ACTION_ADDED: 'marketing_automation_action_added',
    TRACK_MARKETING_AUTOMATION_FIRED: 'marketing_automation_fired',
    TRACK_MOBILE_ACTIVITY_VOICE_LOG: 'mobile_activity_voice_log',
    TRACK_MOBILE_ACTIVITY_LOGGED: 'mobile_activity_logged',
    TRACK_ENGAGEMENT_LEAD_PAGE_OPENED: 'engagement_lead_page_opened',
    TRACK_ENGAGEMENT_LEAD_ACTION_CLICKED: 'engagement_lead_action_clicked',
    TRACK_OUT_OF_OUTCOMES_MODAL_VIEWED: 'out_of_outcomes_modal_viewed',
    TRACK_COMMAND_PALETTE_OPENED: 'command_palette_opened',
    TRACK_COMMAND_PALETTE_ACTION_EXECUTED: 'command_palette_action_executed',
    TRACK_COMMAND_PALETTE_NAVIGATION_EXECUTED: 'command_palette_navigation_executed',
    TRACK_COMMAND_PALETTE_AI_SUGGESTION_CLICKED: 'command_palette_ai_suggestion_clicked',
    TRACK_COMMAND_PALETTE_GHOST_TEXT_ACCEPTED: 'command_palette_ghost_text_accepted',
    TRACK_LEAD_RESEARCHER_SETTINGS_UPDATED: 'lead_researcher_settings_updated',
    TRACK_LEAD_RESEARCHED: 'lead_researched',
    TRACK_LEAD_RESEARCHER_SETTINGS_VIEWED: 'lead_researcher_settings_viewed',
    TRACK_ONBOARDING_BUTTON_CLICKED_FROM_CR: 'onboarding_button_clicked_from_cr',
    TRACK_TIME_FILTER_CHANGED_IN_CR: 'time_filter_changed_in_cr',
    TRACK_THREAD_SIDEBAR_OPENED_IN_CR: 'thread_sidebar_opened_in_cr',
    TRACK_KNOWLEDGE_GAPS_LINK_CLICKED_IN_CR: 'knowledge_gaps_link_clicked_in_cr',
    TRACK_CR_BUTTON_CLICKED_FROM_THREADS_HEADER: 'cr_button_clicked_from_threads_header',
    TRACK_SHARED_EMAIL_INBOX_CONFIGURED: 'shared_email_inbox_configured',
    TRACK_PEEP_PAGES_REDESIGN_OPT_OUT: 'peep_pages_redesign_opt_out',
    TRACK_PEEP_PAGES_REDESIGN_OPT_IN: 'peep_pages_redesign_opt_in',
    TRACK_PEEP_PAGES_REDESIGN_FORCE_OPT_IN: 'peep_pages_redesign_force_opt_in',
    TRACK_PEEP_PAGES_REDESIGN_LAYOUT_CUSTOMIZER_VIEWED: 'peep_pages_redesign_layout_customizer_viewed',
    TRACK_PEEP_PAGES_REDESIGN_LAYOUT_UPDATED: 'peep_pages_redesign_layout_updated',
    TRACK_PROMO_USER_GETS_202604_QUOTES: 'promo_user_gets_202604_quotes',
    TRACK_PEEP_RELATIONSHIP_MARKED_AS_FORMER: 'peep_relationship_marked_as_former',
    TRACK_PEEP_VALUE_MARKED_AS_FORMER: 'peep_value_marked_as_former',
    TRACK_FOLLOW_UP_TASKS_ONBOARDING_VIEWED: 'follow_up_tasks_onboarding_viewed',
    TRACK_FOLLOW_UP_TASKS_ONBOARDING_ENABLED: 'follow_up_tasks_onboarding_enabled',
} as const;
